// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivityList {
  position: relative;
  width: 100%;
  height: 100%;
  flex-grow: 1;
}
.ActivityList .ActivityList-Empty {
  text-align: center;
  margin-top: 2rem;
  color: rgba(0, 0, 0, 0.25);
}
.ActivityList .ActivityItem {
  display: flex;
  border: none;
}
.ActivityList .ActivityItem .ActivityItem-Icon {
  padding: 0.5rem 1rem 0 0;
  font-size: 1.25rem;
}
.ActivityList .ActivityItem .ActivityItem-Info {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/common/Activity/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;AAEJ;AAAE;EACE,aAAA;EACA,YAAA;AAEJ;AADI;EACE,wBAAA;EACA,kBAAA;AAGN;AADI;EACE,aAAA;EACA,sBAAA;AAGN","sourcesContent":[".ActivityList {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  .ActivityList-Empty {\n    text-align: center;\n    margin-top: 2rem;\n    color: rgba(0, 0, 0, 0.25);\n  }\n  .ActivityItem {\n    display: flex;\n    border: none;\n    .ActivityItem-Icon {\n      padding: 0.5rem 1rem 0 0;\n      font-size: 1.25rem;\n    }\n    .ActivityItem-Info {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
